import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, overline, children }) {
  return (
    <div className="min-h-screen bg-cream text-ink font-sans">
      <header className="border-b border-ink/10 bg-cream/85 backdrop-blur-md">
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="legal-back-home">
            <span className="w-9 h-9 rounded-full bg-terracotta flex items-center justify-center text-cream font-serif-elegant text-lg leading-none">
              k
            </span>
            <span className="font-serif-elegant text-xl md:text-2xl text-ocean leading-none">
              Kerstin Cloodt
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-ocean hover:text-terracotta transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={15} />
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 md:px-10 py-16 md:py-24">
        {overline && (
          <span className="text-xs uppercase tracking-[0.28em] text-terracotta">
            {overline}
          </span>
        )}
        <h1 className="mt-4 font-serif-elegant text-4xl md:text-5xl text-ocean leading-tight">
          {title}
        </h1>
        <div className="mt-10 space-y-6 text-ink/85 leading-relaxed font-light text-base md:text-lg legal-content">
          {children}
        </div>
      </main>

      <footer className="border-t border-ink/10 py-8 text-center text-xs text-ink/50">
        © {new Date().getFullYear()} Kerstin Cloodt
      </footer>
    </div>
  );
}
